module.exports = __webpack_public_path__ + "img/origamipay.74939205.png";